<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <div class="navbar-brand"><strong>{{uuid ? company.name : 'New Company'}}</strong></div>
    <div *ngIf="uuid">
        <div class="ms-auto d-flex flex-row" style="gap: 5px">
            <a class="btn btn-sm btn-outline-primary" *ngIf="!addExistingForm" [routerLink]="['/lo/admin/user/form', uuid ? uuid : '']">&#43; Add New User</a>
            <a class="btn btn-sm btn-outline-primary ms-2" *ngIf="!addExistingForm && availableUser.length > 0" (click)="addExistingFormToogle()">&#43; Add Existing User</a>
            <div class="d-flex flex-row align-items-center mt-md-0 mt-2" *ngIf="addExistingForm">
                <span class="me-2 text-nowrap">Select User</span>
                <select class="form-control me-2" [(ngModel)]="existing_user_id">
                    <option *ngFor="let au of availableUser" [value]="au.id">{{au.name}} ({{au.username}})</option>
                </select>
                <button class="btn btn-sm btn-primary me-2" (click)="addExistingUser()">Add</button>
                <button class="btn btn-sm btn-outline-primary" (click)="addExistingFormToogle()">Cancel</button>
            </div>
        </div>
    </div>
  </div>
</nav>
<div class="row mt-2">
  <div class="col-md-3" *ngIf="showEditForm">
    <div class="card">
        <div class="card-header">
            <div class="card-title mb-0"><strong>Company</strong></div>
        </div>
        <div class="card-body">
            <form #f="ngForm" (ngSubmit)="f.valid && companyUpdate()" novalidate>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="code" class="form-label">Name <em>*</em></label>
                            <input type="text" class="form-control" id="name" name="name" #name="ngModel" [(ngModel)]="company.name" required>
                            <div *ngIf="f.submitted && name.invalid" class="invalid-feedback">
                                <div *ngIf="name.errors.required">Name is required</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="referral_rate" class="form-label">Default Referral Rate <em>*</em></label>
                            <input type="text" class="form-control" id="referral_rate" name="referral_rate" #referral_rate="ngModel" [(ngModel)]="company.referral_rate" required>
                            <div *ngIf="f.submitted && referral_rate.invalid" class="invalid-feedback">
                                <div *ngIf="referral_rate.errors.required">Referral Rate is required</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="status" class="form-label">Status <em>*</em></label>
                            <select class="form-control" id="status" name="status" #status="ngModel" [(ngModel)]="company.status" required>
                                <option [value]="1">Active</option>
                                <option [value]="0">Disabled</option>
                            </select>
                            <div *ngIf="f.submitted && status.invalid" class="invalid-feedback">
                                <div *ngIf="status.errors.required">Status is required</div>
                            </div>
                        </div>
                    </div>
                </div>
                <button type="submit" class="btn btn-primary" [disabled]="savingCompany">{{savingCompany ? 'Saving…' : 'Update'}}</button>
            </form>
        </div>
    </div>
  </div>
  <div class="mt-3 mt-md-0" [ngClass]="{'col-md-9': showEditForm, 'col-md-12': !showEditForm}" *ngIf="uuid">
    <app-table #table></app-table>
  </div>
</div>
